import {useEffect, useRef} from 'react';

export const useUpdate = (fn: () => void, dependency: any[]) => {
  const count = useRef(0)

  useEffect(() => {
    count.current += 1
  })

  // useEffect 在 tags (如果是对象,必须为新的对象)变化时, 做一件事情
  useEffect(() => {
    if (count.current > 1) {
      fn();
    }
    // deps 只接受数组, 现在不能确定你给 deps 传递了什么类型
  }, [dependency, fn]); // 不可变数据
}
